export function normaliseStringToNumber(value: string): string {
  return value.replace(/\D/g, "");
}

export function normaliseStringToNumberWithPeriod(value: string): string {
  const onlyNumbersAndDots = value.replace(/[^0-9.]/g, "");
  const valueSplitOnPeriod = onlyNumbersAndDots.split(".");
  let result = valueSplitOnPeriod.slice(0, 2).join(".");
  if (result.indexOf(".") === 0) {
    result = "0" + result;
  }
  return result;
}

export function clampNumber(value: number, min: number, max: number) {
  return Math.max(min, Math.min(value, max));
}

export function calculateBMI(height: number, weight: number) {
  const result = weight / Math.pow(height / 100, 2);
  return isFinite(result) ? result : 0;
}

export function convertLength(
  fromUnit: string,
  toUnit: string,
  value: number
): number {
  const unitConversionPair = `${fromUnit}, ${toUnit}`;

  switch (unitConversionPair) {
    case "CM, M":
      return value / 100;
    case "M, CM":
      return value * 100;
    case "CM, IN":
      return value / 2.54;
    case "IN, CM":
      return value * 2.54;
    case "M, IN":
      return value * 39.37;
    case "IN, M":
      return value / 39.37;
    default:
      return value;
  }
}

export function convertStringToJSON(jsonString: string) {
  try {
    return JSON.parse(jsonString);
  } catch {
    return {};
  }
}

export function convertPxToRem(px: number): string {
  return `${px / 16}rem`;
}
